module.exports = __webpack_public_path__ + "11bbb1ed7a60eec89c00e81ad308494e.svg";